    <app-table-grid #RelatedProfilesGrid id="switchProfileGrid"  *ngIf="tableContent?.length" [hasSearch]="true" [lazyPager]="false"
      [totalRecords]="totalRecords" [hasAddButton]="false" [tableHeader]="tableHeader" [tableContent]="tableContent"
      [showRows]="5" [hasPager]="true"  gridTitle="{{ gridTitle }}" [editMode]="false" (onEditClick)="onEditClick($event)"
      [selectionMode]="selectionModeEnum.single" [selectAll]="false" [keyField]="keyField"
      [emitRowClickEvent]="false" [selectedItems]="selectedItems" (onRowClick)="onRowClick($event)"
      (onSelectedItems)="onSelectedItems($event)"
      ></app-table-grid>
